import dynamic from 'next/dynamic';
import styles from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function PoweroceanPlus() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`poweroceanPlus ${styles['poweroceanPlus']}`}>
            <IndexDynamic />
        </div>
    );
}
